// extracted by mini-css-extract-plugin
module.exports = {"btn":"Questionnaire_btn__1C7Cn","wrapper":"Questionnaire_wrapper__2eLB4","logo":"Questionnaire_logo__3HbLd","banner":"Questionnaire_banner__eRaev"};